import React, { lazy } from 'react';
import { AppRoute } from '../routes.types';

const AllyPage = lazy(() => import('../../venues/pages/AllyPage/AllyPage'));

export const ALLY_ROUTES: AppRoute[] = [
    { path: '', element: <AllyPage /> },
];
